import React, { useMemo } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "swiper/css/navigation";
import "swiper/css/pagination";
import Button from "../../../components/Button";
import useEvents from "../../../hooks/useEvents";
import useWindowSize from "../../../hooks/useWindowSize";
import { BarracksState } from "../../../redux/pages/barracks/barracksSlice";
import { useBarracksUIContext } from "../BarracksContext";
import { useAppSelector } from "../../../hooks/reduxHook";
import { isMobile } from "react-device-detect";
import { useAppTranslation } from "../../../i18n/useAppTranslation";

const BarracksButtons = () => {
  const { halloweenEvent } = useEvents();
  const windowSize = useWindowSize();
  const { t } = useAppTranslation(["barracks"]);

  const buildingData = useAppSelector((state: any) => state?.buildings);

  const { barrackBuildingInfo }: BarracksState = useAppSelector(
    ({ barracks }) => {
      return {
        barrackBuildingInfo: barracks.barrackBuildingInfo,
      };
    },
    shallowEqual
  ) as BarracksState;

  const barracksContext = useBarracksUIContext();
  const barracksUIProps = useMemo(() => {
    return {
      selectedTab: barracksContext?.selectedTab,
      setConfirmDialog: barracksContext?.setConfirmDialog,
      setUpgradeLoading: barracksContext?.setUpgradeLoading,
      setTrainDialog: barracksContext?.setTrainDialog,
      setInstantHealDialog: barracksContext?.setInstantHealDialog,
    };
  }, [
    barracksContext?.setConfirmDialog,
    barracksContext?.setUpgradeLoading,
    barracksContext?.setTrainDialog,
    barracksContext?.setInstantHealDialog,
    barracksContext?.selectedTab,
  ]);

  if (barracksUIProps?.selectedTab)
    return <div style={{ minWidth: 180 }}></div>;
  return (
    <div>
      {windowSize?.width > 800 && barrackBuildingInfo?.level !== 8 && (
        <Link to="/home#upgrade-barracks">
          <Button
            badge={
              halloweenEvent.isActive &&
              buildingData?.[3]?.discount > 0 && (
                <>
                  <div className="dark-yellow fs-lg">
                    {buildingData?.[3]?.discount}%
                  </div>
                  <small className="dark-yellow">{t("barracks:stats.off")}</small>
                </>
              )
            }
            className="w-100 brk-step7"
            variant="wide"
          >
            {t("barracks:labels.upgradeBarracks")}
          </Button>
        </Link>
      )}
      <div className="d-flex flex-column w-full align-items-center justify-content-between mt-3 mt-md-0 w-100 gap-2">
        <Button
          className="brk-step "
          onClick={() => barracksUIProps?.setTrainDialog?.(true)}
          variant="wide-primary"
          size={isMobile ? "small" : "medium"}
        >
          {t("barracks:labels.trainNewTroop")}
        </Button>
        <Button
          className="w-100 bg-100 "
          style={!isMobile?{maxHeight:45}:{}}
          size={isMobile ? "small" : "medium"}
          onClick={() =>
            barracksUIProps?.setInstantHealDialog?.({
              open: true,
              troopId: 0,
              troop: undefined,
              targetType: "all",
            })
          }
          variant="wide-success"
          
        >
          {t("barracks:labels.instantHeal")}
        </Button>

        {isMobile && (
          <Link to="/home#upgrade-barracks">
            <Button
              badge={
                halloweenEvent.isActive &&
                buildingData?.[3]?.discount > 0 && (
                  <>
                    <div className="dark-yellow fs-lg">
                      {buildingData?.[3]?.discount}%
                    </div>
                    <small className="dark-yellow">{t("barracks:stats.off")}</small>
                  </>
                )
              }
              className=" brk-step7"
              variant="wide"
              size={isMobile ? "small" : "medium"}
            >
              {t("barracks:labels.upgradeBarracks")}
            </Button>
          </Link>
        )}
      </div>
    </div>
  );
};

export default BarracksButtons;
